import { Suggestions } from '@mint-sdk/api-recommendations';
import { atom } from 'jotai';

export const bulkPublishSelectionAtom = atom<
  Map<number, Suggestions.SuggestionResponseType>
>(new Map());

export const removeFromBulkPublishSelectionAtom = atom(
  null,
  (get, set, id: number) => {
    const current = get(bulkPublishSelectionAtom);
    if (!current.has(id)) return;
    const next = new Map(current);
    next.delete(id);
    set(bulkPublishSelectionAtom, next);
  },
);

export const toggleBulkPublishSelectionAtom = atom(
  null,
  (get, set, suggestion: Suggestions.SuggestionResponseType) => {
    const current = get(bulkPublishSelectionAtom);
    const next = new Map(current);
    if (next.has(suggestion.id)) {
      next.delete(suggestion.id);
    } else {
      next.set(suggestion.id, suggestion);
    }
    set(bulkPublishSelectionAtom, next);
  },
);

export const clearBulkPublishSelectionAtom = atom(null, (_get, set) => {
  set(bulkPublishSelectionAtom, new Map());
});
